import React from "react";
import { Props } from "./IbonusStub";
import styles from "./bonus-stub.module.scss";
import MyButton from "../myButton";
import redirectTo from "../../utils/redirectTo";
import { inject, observer } from "mobx-react";

const BonusStub = (props) => {
  const { authStore } = props;
  const addDonation = () => {
    redirectTo(authStore?.user ? "/profile/add_donation" : '/login?next=/profile/add_donation');
  };
  
  return (
    <div className={`${styles.Stub} container`}>
      <div className={styles.Blur}></div>
      <div className={styles.StubContent}>
        <h1 className={styles.StubContentTitle}>Необходима донация</h1>
        <p className={styles.StubContentText}>
          Чтобы взять бонус, нужно иметь подтверждённую донацию за последние 180
          дней
        </p>
        <MyButton text="Добавить донацию" width="300px" onClick={addDonation} />
      </div>
    </div>
  );
};

export default inject(
  "authStore",
)(observer(BonusStub));
